import { Controller } from "@hotwired/stimulus"

// Booking a timesheet on a pool site ("Pool-Baustelle") requires a written explanation in
// the notes field — see ConfigurableTimeSheet#validate_pool_site_explanation. This controller
// keeps the form in step with that rule: it reveals the notes field on templates that would
// otherwise hide it, and surfaces the hint, as soon as a pool site is selected.
//
// The server validates regardless; this only prevents the employee from hitting a blocking
// error with no visible field to fix it.
export default class extends Controller {
  static targets = ["siteSelect", "notesWrapper", "notesHint"]
  // siteIds: ids of the bookable sites that are pool sites.
  // notesForced: true when the notes field exists only because a pool site is bookable —
  // the template itself hides it, so it must disappear again when a normal site is picked.
  static values = { siteIds: Array, notesForced: Boolean }

  connect() {
    this.sync()
  }

  siteChanged() {
    this.sync()
  }

  sync() {
    const active = this.poolSiteSelected

    if (this.hasNotesWrapperTarget && this.notesForcedValue) {
      this.notesWrapperTarget.classList.toggle("hidden", !active)
    }
    if (this.hasNotesHintTarget) {
      this.notesHintTarget.classList.toggle("hidden", !active)
    }
  }

  get poolSiteSelected() {
    if (!this.hasSiteSelectTarget) return false

    const value = parseInt(this.siteSelectTarget.value, 10)
    return !Number.isNaN(value) && this.siteIdsValue.includes(value)
  }
}
